import { TODO } from '@b2c/types/index';
import { IPromise } from 'angular';
import { IInjectable, StateParams } from 'angular-ui-router';
import { MembershipService } from '../services/membership/membership.service';

export function VerifyMemberResolver(): IInjectable {
  return [
    '$stateParams',
    'MembershipService',
    function VerifyMember($stateParams: StateParams, membershipService: MembershipService): IPromise<TODO> {
      const tenantId = $stateParams.tenantId;

      return membershipService.verifyMemberSession(tenantId);
    },
  ];
}
